import React, { useState , useEffect} from "react";
import "./academicCalenderPdf.css"; // Import the CSS file
import { resources } from "../Resourses/Resources";
import axios from "axios";

const AcademicCalenderPdf = () => {
  const [programType, setProgramType] = useState("");
  const [courseName, setCourseName] = useState("");
  const [academicYear, setAcademicYear] = useState("");
  const [file, setFile] = useState(null);



  useEffect(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth(); // 0 = Jan, 6 = July
    const startYear = month >= 6 ? year : year - 1;
    const endYear = startYear + 1;
    setAcademicYear(`${startYear}-${endYear}`);
  }, []);

  const generateYearOptions = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const currentStartYear = month >= 6 ? year : year - 1;

    const options = [];
    for (let i = currentStartYear - 9; i <= currentStartYear; i++) {
      options.push(`${i}-${i + 1}`);
    }
    return options;
  };




  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!programType || !academicYear || !file) {
      alert("Please fill all fields and upload a file.");
      return;
    }

    const academicCalendarPrimary = {
      academicCalendarPrimary: {
        academicYear: academicYear,
        course: programType,
      },
      filePath: "",
      fileName: "",
      uploadBy: "",
    };

    console.log("--------------->", academicCalendarPrimary);

    const formData = new FormData();
    formData.append(
      "academicCalendar",
      new Blob([JSON.stringify(academicCalendarPrimary)], {
        type: "application/json",
      })
    );
    formData.append("file", file); // match the @RequestParam("file") in your backend

    axios
      .post(
        `${resources.APPLICATION_URL}academicCalendar/saveAcademicCalendar`,
        formData
      )
      .then((response) => {
        setProgramType("");
        setCourseName("");
        setAcademicYear("");
        setFile(null);
        console.log(response);
        alert("Upload successful!");
      })
      .catch((error) => {
        console.log(error);
        alert("Upload failed.");
      });

    // try {
    //   const response = await fetch(`${resources.APPLICATION_URL}academicCalendar/saveAcademicCalendar`, {
    //     method: "POST",
    //     body: formData,
    //   });

    //   if (!response.ok) {
    //     throw new Error("Failed to upload");
    //   }

    //   const data = await response.json();
    //   alert("Upload successful!");

    //   // Reset form fields
    //   setProgramType("");
    //   setCourseName("");
    //   setAcademicYear("");
    //   setFile(null);
    // } catch (error) {
    //   console.error("Upload error:", error);
    //   alert("Upload failed.");
    // }
  };

  return (
    <div className="academic-calender-pdf-container">
      <h2 className="academic-calender-pdf-title">Upload Academic Calendar</h2>
      <form
        className="academic-calender-pdf-form"
        onSubmit={handleSubmit}
        encType="multipart/form-data"
      >
        <div className="academic-calender-pdf-form-group">
          <label>Program Type</label>
          <select
            value={programType}
            onChange={(e) => setProgramType(e.target.value)}
            required
          >
            <option value="">--Select--</option>
            <option value="UG">UG</option>
            <option value="PG">PG</option>
            <option value="Diploma">Diploma</option>
          </select>
        </div>

        {/* <div className="academic-calender-pdf-form-group">
          <label>Course Name</label>
          <input
            type="text"
            value={courseName}
            onChange={(e) => setCourseName(e.target.value)}
            required
          />
        </div> */}

        <div className="academic-calender-pdf-form-group">
          <label>Academic Year</label>
          <select
            value={academicYear}
            onChange={(e) => setAcademicYear(e.target.value)}
            required
          >
            {generateYearOptions().map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>

        <div className="academic-calender-pdf-form-group">
          <label>Upload PDF</label>
          <input
            type="file"
            accept="application/pdf"
            onChange={(e) => setFile(e.target.files[0])}
            style={{ color: "black" }}
            required
          />
        </div>

        <button className="academic-calender-pdf-submit" type="submit">
          Submit
        </button>
      </form>
    </div>
  );
};

export default AcademicCalenderPdf;
